exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-79f1a514]{text-align:center;color:#192A44;margin-bottom:10px\n}\n.body[data-v-79f1a514]{text-align:center;margin-bottom:22px\n}\n.footer[data-v-79f1a514]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:15px;width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.btn--long[data-v-79f1a514]{-webkit-box-shadow:0 11px 24px rgba(0,0,0,0.07);box-shadow:0 11px 24px rgba(0,0,0,0.07)\n}\n@media (min-width: 768px){\n.btn--long[data-v-79f1a514]{width:70%\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79f1a514","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/configurator/components/ResumeConfigurationModal.vue
// module id = rqro
// module chunks = 15